import { IPromise } from 'angular';
import { ServiceLocator } from '../../app/ServiceLocator';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { DeleteFlowVersionsRequest } from '../../ts/ServerApi/requests/DeleteFlowVersionsRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { GetFlowVersionsRequest, GetFlowVersionsResult } from '../serverApi/requests/GetFlowVersionsRequest';
import { FlowRevision } from '../serverApi/types/FlowRevision';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';

export class FlowRevisionsResource {
  private fetcher = new WebClientListResourceFetcher(GetFlowVersionsRequest, (result: GetFlowVersionsResult) => result.versions);

  public all(): ResourceQuery<FlowRevision> {
    return new ResourceQuery(this.fetcher);
  }

  public del = (id: string): IPromise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteFlowVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }
}

export const FlowRevisions = new FlowRevisionsResource();
